<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <d2-container>
        <h2>材料列表</h2>
        <el-form ref="elForm" :model="formData" size="medium" label-width="100px">
            <el-row>
                <el-form-item label="材料名称" prop="dd">
                    <el-input v-model="listQuery.materialName" placeholder="材料名称" clearable :style="{width: '763px'}"></el-input>
                </el-form-item>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>


        <!--表格-->
        <el-button size="small" class="filter-item"  style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">新增材料</el-button>
        <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">
            <el-table-column
                    prop="materialId"
                    type="selection"
                    width="55" label="序号">
            </el-table-column>
            <el-table-column
                    prop="materialName"
                    label="材料名称"
                    width="380">
            </el-table-column>
            <el-table-column
                    prop="explainText"
                    label="描述信息"
                    width="280"
                     >
            </el-table-column>
            <el-table-column
                    label="上报类型" >
                <template slot-scope="scope">{{ materialType(scope.row.materialType) }}</template>
            </el-table-column>
            <el-table-column
                    prop="formType"
                    label="表单编码" >
            </el-table-column>
            <el-table-column
                    prop="sort"
                    label="排序"
            >
            </el-table-column>
            <el-table-column
                    prop="sort"
                    label="模板"
            >
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="downloadFile(scope.row.templateFile)" v-if="scope.row.templateFile">下载查看</a>
                    <span v-else-if="scope.row.materialType!=1">未上传</span>
                    <a href="javascript:void(0)" @click="inputForm(scope.row)" v-if="scope.row.materialType==1 || scope.row.materialType==2">
                        <span v-if="scope.row.templateFile || scope.row.materialType!=1">&nbsp;|&nbsp;</span>在线表单
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="300">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                    <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>


        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :model="form" ref="form" label-width="100px">
                <el-form-item label="材料名称">
                    <el-input v-model="form.materialName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="描述信息">
                    <el-input v-model="form.explainText" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="上报类型">
                    <el-select v-model="form.materialType" placeholder="请选择">
                        <el-option
                                v-for="item in materialTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="表单类型" v-if="form.materialType==1 || form.materialType==2">
                  <el-select v-model="form.formType" placeholder="请选择">
                    <el-option
                        v-for="item in formTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" placeholder="请输入,数字越大越靠前"></el-input>
                </el-form-item>
                <el-form-item label="模板文件" v-if="dialogFormVisible">
                    <upload-component v-on:on-upload="(e)=>{form.templateFile=e.fileSerial;form.templateName=e.fileName;}" :fileSerial="form.templateFile" :fileName="form.templateName" :show="'true'">
                        <template v-slot:default><span style="font-size:10px">上传模板文件提供企业参考</span> </template>
                    </upload-component>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')"  size="small">取 消</el-button>
                <el-button v-if="dialogStatus=='create'"  size="small" type="primary" @click="create('form')">保存</el-button>
                <el-button v-if="dialogStatus=='update'" type="primary" size="small" @click="update('form')">更新</el-button>
            </div>
        </el-dialog>


        <el-dialog width="1024px" :title="'表单录入'" :visible.sync="materialFormVisible" v-if="materialFormVisible">
            <form-view @close="close()" @success="formSuccess" :formId="currentRow.formId" :formType="formType" :prop="userStatus" :key="formType"></form-view>
        </el-dialog>

    </d2-container>
</template>


<script>
    import {
        page,
        addObj,
        getObj,
        delObj,
        putObj
    } from '@/api/admin/sysBaseMaterial/index';
    import uploadComponent from './upload-com.vue'
    import { mapGetters } from 'vuex';
    import {download} from "../../../api/admin/sysFiles/index";
    import FormView from "../sysForm/";
    export default {
        components:{
            uploadComponent,
            FormView
        },
        name: 'sysBaseMaterial',
        data() {
            return {
                formData: {
                    materialName: undefined,
                },
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    materialName: null,
                },
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '创建'
                },
                tableKey: 0,
                form:{
                    templateFile: null,
                    templateName: null,
                    materialId:null,
                    materialName:null,
                    explainText:null,
                    materialType:null,
                    formType:null,
                    sort:null,

                },
                materialTypes:[
                    { value: 0, label: '附件上传' },
                    { value: 1, label: '表单录入' },
                    { value: 2, label: '表单或录入' },
                ],
                formTypes:[
                  {value: "1", label:'加油站注册信息'},
                  {value: "2", label:'承诺书'},
                  {value: "5", label:'安全评价报告'},
                  {value: "12", label:'消防清单'},
                  {value: "13", label:'自用车辆、机械清单'},
                  {value: "15", label:'雷电防护装置设计事项备案意见'},
                  {value: "18", label:'油品意向'},
                  {value: "20", label:'合作方相关资料'},
                  {value: "23", label:'企业法人证明材料'},

                ],
                materialFormVisible:false,
                formType: null,
                currentRow:null,
                userStatus:{
                    "preview":true,
                }
            }
        },
        created() {
            this.getList();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        methods: {
            materialType(materialType){
              if(materialType==0){return "附件"}
              else if(materialType==1){return "录入"}
              else{return "附件或录入"}
            },
            getList() {
                this.listLoading = true;
                page(this.listQuery).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
            downloadFile(id){
                download(id);
            },
            inputForm(row){
                this.materialFormVisible = true;
                this.formType = row.formType;
                this.currentRow = row;
            },
            close(flush){
                this.materialFormVisible=false;
                this.currentRow=null;
                this.formType = null;
            },
            handleFilter() {
                this.getList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getList();
            },
            handleCreate() {
                this.resetTemp();
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
            },
            handleClick(row) {
                getObj(row.materialId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'view';
                    });
            },handleUpdate(row) {
                getObj(row.materialId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'update';
                    });
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.materialId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },
            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        addObj(this.form)
                            .then(() => {
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.form.password = undefined;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetTemp() {
                this.form = {
                    templateFile: null,
                    templateName: null,
                    materialId:null,
                    materialName:null,
                    explainText:null,
                    materialType:null,
                    formType:null,
                    sort:null,
                };
            },
            resetForm(){
                this.listQuery={
                    page: 1,
                    limit: 20,
                    materialName: null,
                }
            }
        }
    }
</script>

